import {Observable, Subject} from 'rxjs';

import {take} from 'rxjs/operators';
import {isDefined} from '../utils/utils';
import { HttpClient } from '@angular/common/http';

export interface GenericApiResponse {
    result: string,
    message?: string,
    code?: string,
    args?: any,
    docs?: string
}

// TODO implement proper type
export type ApiError = any;

export interface ApiMetaInfo extends ApiPaginationInfo {
}

export interface APIResult<T> {
    links: ApiMetaInfo,
    data: T
}

export interface PaginatedResult<T> {
    nextPageRequest(): ApiSourcedPaginationRequest<T>;
}

export interface ApiPaginationInfo {
    nextLink: string,
    prevLink: string,
    // totalCount: number
}

export interface QueryMetadata {
    filters?: { [k: string /**/]: string };
    limit?: number;
    offset?: number;
}

export function queryMetadataToQueryParams(metadata: QueryMetadata): any {
    let params: any = {};
    for (let key in metadata.filters) {
        params[key] = metadata.filters[key];
    }
    if(metadata.limit) {
        params['limit'] = metadata.limit;
    }
    if(metadata.offset !== undefined) {
        params['offset'] = metadata.offset;
    }
    return params;
}

/**
 * An API GET
 */
export class ApiSourcedPaginationRequest<T> {
    constructor(private uri: string, private http: HttpClient, private queryParams?: any, private resultMapper: (result: any) => T = (_ => _)) {
    }

    private value: Subject<ApiSourcedPaginationResult<T>> = new Subject<ApiSourcedPaginationResult<T>>();

    fetch(): Observable<ApiSourcedPaginationResult<T>> {
        this.http.get<APIResult<any>>(this.uri, {params: this.queryParams}).pipe(take(1)).subscribe({ next: (response) => {
            this.value.next(new ApiSourcedPaginationResult<T>(isDefined(response.data) ? response.data.map(this.resultMapper) : undefined, response.links, this.http, this.queryParams, this.resultMapper));
            }, error: (err) => {
                this.value.error(err);
            }
        });
        return this.value.asObservable();
    }
}

/**
 * An API GET
 */
export class ApiSourcedPaginationResult<T> implements PaginatedResult<T> {
    constructor(public result: Array<T>, public paginationInfo: ApiPaginationInfo, private http: HttpClient, private queryParams?: any, private resultMapper: (result: any) => T = (_ => _)) {
    }

    hasPreviousPage(): boolean {
        return isDefined(this.paginationInfo.prevLink);
    }

    previousPageRequest(): ApiSourcedPaginationRequest<T> {
        return new ApiSourcedPaginationRequest<T>(this.paginationInfo.prevLink, this.http, {}, this.resultMapper);
    }

    hasNextPage(): boolean {
        return isDefined(this.paginationInfo.nextLink);
    }

    nextPageRequest(): ApiSourcedPaginationRequest<T> {
        return new ApiSourcedPaginationRequest<T>(this.paginationInfo.nextLink, this.http, {}, this.resultMapper);
    }

}
